import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import config from 'utils/config';
import FormField from 'components/FormField';
import CheckboxOption from 'components/CheckboxOption';
import Button from 'components/Button';
import Flex, { Box } from 'components/Flex';
import ContentContributionsModal from 'screens/ContentContributionModal';
import Stack from 'components/Stack';
var AdditionalOptionsField = function AdditionalOptionsField(_ref) {
  var _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? true : _ref$horizontal,
    isMemberContributionsEnabled = _ref.isMemberContributionsEnabled,
    isNumberingEnabled = _ref.isNumberingEnabled,
    onChangeMemberContributions = _ref.onChangeMemberContributions,
    onChangeNumbering = _ref.onChangeNumbering,
    isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var memberContributionId = "member-contributions-".concat(uniqueId);
  var contentNumberingId = "content-numbering-".concat(uniqueId);
  var hasMemberContributionsOption = config.memberContributions;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isContentContributionModalOpen = _useState2[0],
    setContentContributionModalOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormField, {
    as: "fieldset",
    label: t('panel_additional_options_title'),
    horizontal: horizontal,
    horizontalLabelOffset: 0
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(CheckboxOption, {
    label: t('actions_display_content_numbers'),
    checked: isNumberingEnabled,
    onChange: onChangeNumbering,
    id: contentNumberingId
  }), hasMemberContributionsOption && /*#__PURE__*/React.createElement(Flex, {
    align: "top"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    mr: "auto"
  }, /*#__PURE__*/React.createElement(CheckboxOption, {
    label: t('actions_allow_member_contribution'),
    checked: isMemberContributionsEnabled,
    onChange: onChangeMemberContributions,
    id: memberContributionId,
    disabled: isDisabled
  })), !isDisabled && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    icon: "info",
    variant: "transparent",
    onClick: function onClick() {
      return setContentContributionModalOpen(true);
    },
    size: "small",
    "aria-describedby": memberContributionId
  }, t('actions_info')))))), isContentContributionModalOpen && /*#__PURE__*/React.createElement(ContentContributionsModal, {
    onClose: function onClose() {
      return setContentContributionModalOpen(false);
    }
  }));
};
export default AdditionalOptionsField;